import { Input, Form, Grid, Message } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import moment from 'moment';
import React from 'react';
import _ from 'lodash';

import { MEAL_SUMMARY_FORM_NAME } from 'Common/FormEnum';
import {
  DatePickerField,
  withReduxForm,
  SelectField,
} from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { MealSummaryFieldEnum as Fields } from 'Common/FieldEnum';
import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { formatToCash } from 'Common/FormHelper';
import withKeyboard from 'Common/Components/Keyboard/withKeyboard';
import withReduxFormBlur from 'Common/Components/Keyboard/withReduxFormBlur';
import { LAYOUT_TYPES } from 'Common/Components/Keyboard/constants';
import { SiteComponent } from 'Common/SiteComponent';

const MEAL_OPTIONS = Object.keys(MealTypesEnum).map(key => ({
  label: key,
  value: MealTypesEnum[key],
}));

const KeyboardInput = withKeyboard(Input);

const InputField = withReduxForm(withReduxFormBlur(KeyboardInput));

class MealSummaryForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.inputRefs = [React.createRef(), React.createRef()];
  }
  activeInputIndex = 0;

  onKeyboardInputFocus = index => e => {
    const { change } = this.props;
    const {
      target: { name, value },
    } = e;

    this.activeInputIndex = index;

    if (name) {
      const parsedValue = Number(value) || 0;

      if (parsedValue === 0) {
        change(name, '');
      }
    }
  };

  onKeyboardInputTab = () => {
    const nextInputIndex = this.activeInputIndex + 1;

    if (nextInputIndex === this.inputRefs.length) {
      if (
        _.has(
          this.inputRefs,
          `${this.activeInputIndex}.current.wrappedInstance.inputRef.current.inputRef.current`
        )
      ) {
        this.inputRefs[
          this.activeInputIndex
        ].current.wrappedInstance.inputRef.current.inputRef.current.blur();
      }
    } else {
      if (_.has(this.inputRefs, `${nextInputIndex}.current.wrappedInstance`)) {
        this.inputRefs[nextInputIndex].current.wrappedInstance.focus();
      }
    }
  };

  render() {
    const {
      loading,
      disableOpenAmount,
      disableCloseAmount,
      users,
      dayClosed,
      summaryRan,
      keyboardAppSidebar,
      modifyDisabled,
      onSiteChange,
    } = this.props;

    let message = null;

    if (dayClosed) {
      message = 'Day closed!';
    } else if (summaryRan) {
      message = 'Summary Has Been Run!';
    }

    return (
      <Form>
        <Grid>
          {message !== null && (
            <Grid.Row columns={1}>
              <Grid.Column>
                <Message content={message} negative size="big" />
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column
              tablet={8}
              widescreen={5}
              className="input-group--btn-group"
            >
              <ReduxFormButtonGroup
                label="Type"
                formName={MEAL_SUMMARY_FORM_NAME}
                options={MEAL_OPTIONS}
                fieldName={Fields.TypeOfSummary}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <SiteComponent
                name={Fields.PrimarySiteId}
                isForm
                isAllRequired={false}
                loading={loading}
                isPrimary
                onChange={onSiteChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                name={Fields.UserId}
                component={SelectField}
                label="User"
                options={users}
                disabled={loading}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row verticalAlign="middle">
            <Grid.Column tablet={6}>
              <Field
                label="Date"
                name={Fields.ClosingDate}
                component={DatePickerField}
                placeholder="Select a date"
                maxDate={moment()}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column tablet={5} widescreen={4}>
              <Field
                label="Opening Cash"
                name={Fields.OpenAmount}
                component={InputField}
                placeholder="Opening Cash Amount"
                formatOnBlur={formatToCash}
                disabled={disableOpenAmount || modifyDisabled}
                maxLength={8}
                appSidebar={keyboardAppSidebar}
                layoutType={LAYOUT_TYPES.NUMERIC}
                forwardRef={this.inputRefs[0]}
                onFocus={this.onKeyboardInputFocus(0)}
                onTabPress={this.onKeyboardInputTab}
              />
            </Grid.Column>
            <Grid.Column tablet={5} widescreen={4}>
              <Field
                label="Closing cash"
                name={Fields.CloseAmount}
                component={InputField}
                placeholder="Closing Cash Amount"
                formatOnBlur={formatToCash}
                disabled={disableCloseAmount || modifyDisabled}
                maxLength={8}
                appSidebar={keyboardAppSidebar}
                layoutType={LAYOUT_TYPES.NUMERIC}
                forwardRef={this.inputRefs[1]}
                onFocus={this.onKeyboardInputFocus(1)}
                onTabPress={this.onKeyboardInputTab}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = (values, ownProps) => {
  const errors = {};

  if (!values[Fields.ClosingDate]) {
    errors[Fields.ClosingDate] = 'Please choose a date.';
  }

  return errors;
};

export default reduxForm({
  form: MEAL_SUMMARY_FORM_NAME,
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(MealSummaryForm);



// WEBPACK FOOTER //
// ./src/pages/mealsummary/components/MealSummaryForm.js